import { createFileRoute } from "@tanstack/react-router";
import { InvitePage } from "@/features/waitlist/InvitePage";

export const Route = createFileRoute("/_authenticated/invites/$code")({
  head: () => ({ meta: [{ title: "Your invite · Pax.co" }] }),
  staticData: { access: "account" },
  component: InviteRoute,
});

function InviteRoute() {
  const { session } = Route.useRouteContext();
  const { code } = Route.useParams();
  return <InvitePage session={session} code={code} />;
}
